import { type StateCreator } from 'zustand';
import { createLens } from '@dhmk/zustand-lens';
import type { IGraph, StoreSlice } from '@/store';
import type { GraphId } from '../types/graph';
import type { GraphState } from '.';

export interface GraphSlice {}

export const createGraphSlice =
  (
    globalStore: StoreSlice,
    id: GraphId
  ): StateCreator<
    GraphState,
    [['zustand/immer', never]],
    [],
    GraphSlice & IGraph
  > =>
  (_set, _get) => {
    const [set, get] = createLens(_set, _get, ['graph']);

    return {
      ...globalStore.graphs.graph(id),
    };
  };
